import * as types from '../types/assignations'
import company from 'api/company'

const assignationsApi = company.assignations

export const setAllAssignationsAct = (assignations) => ({
  type: types.SET_ALL_ASSIGNATIONS,
  assignations,
})

/**
 *
 * @param {Object} params.dashuser Assignations of a specific dashuser
 * @param {Array<String>} params.brands Array conaining the related brand id's
 * @param {Array<String>} params.delegations Array conaining the related delegation id's
 */
export const getAssignations = (params) => (dispatch) =>
  new Promise((resolve, reject) => {
    return assignationsApi.get(params).then(({ data, status }) => {
      if (status === 200) {
        dispatch(setAllAssignationsAct(data.results))

        return resolve(data.results)
      } else {
        return reject(data)
      }
    })
  })
